import {Component, EventEmitter, OnInit} from '@angular/core';
import {ApiRestService} from "../../_services/api-rest.service";
import {ToastrService} from "ngx-toastr";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Destinazione} from "../../Models/destinazione";
import {RitornoPaginazione} from "../../../shared/models/RitornoPaginazione";
import {DestinazioniMoveComponent} from "../destinazioni-move/destinazioni-move.component";
import {Permission} from "../../../Login/_guards/Permission";
import {ServerPaginationService} from "../../../shared/_services/server-pagination.service";

@Component({
  selector: 'app-destinazioni-list-all',
  templateUrl: './destinazioni-list-all.component.html',
  styleUrls: ['./destinazioni-list-all.component.css']
})
export class DestinazioniListAllComponent implements OnInit {
  Items: RitornoPaginazione<Destinazione[]> = {data: [], total: 0}
  Filter: {cliente: string, ordine: string, spedire: boolean, spedito: boolean, page: number, size: number} = {cliente: "", ordine: "", spedire: false, spedito: false, page: 1, size: 50};
  onSpostaClick: EventEmitter<any>= new EventEmitter<any>();
  page = 1;
  pageSize = 50;
  pagesizeserver = 1 // pagine da precaricare da lserver
  newpagegenerated = 1; // pagina per cui è stata fatta la richiesta al server
  constructor(
    private apiRestService: ApiRestService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    public permission: Permission,
    private paginationService: ServerPaginationService
  ) { }

  ngOnInit(): void {
   this.refresh();
    this.onSpostaClick.subscribe(data => {
      if(data) {
        var spostadestinazioni = this.modalService.open(DestinazioniMoveComponent, {
          centered: true,
          backdrop: "static",
          size: 'xl'
        });
        (<DestinazioniMoveComponent>spostadestinazioni.componentInstance).item = data?.item;
        (<DestinazioniMoveComponent>spostadestinazioni.componentInstance).idDestinazione = data?.padre?.id;
        (<DestinazioniMoveComponent>spostadestinazioni.componentInstance).Refresh.subscribe(() => {
          this.refresh()
        });
      }
    })
  }

  update(item: Destinazione){
    this.apiRestService.UpdateDestinazione(item).subscribe(()=>{
      this.refresh();
      this.toastr.success("Modifiche apportate con successo.")
    })
  }

  refresh(page?:number) {
    this.Filter.page = ((page ?? 1) - 1) / this.pagesizeserver + 1;
    this.Filter.size = this.pagesizeserver * this.pageSize;
    this.apiRestService.DestinazioniSearch(this.Filter).subscribe(data => this.Items = data);

  }
  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.refresh(pagetosend);
    }
  }
}
